// extracted by mini-css-extract-plugin
export default {"cartContainer":"LO","summarycontent":"MO","offset":"NO","leaf":"OO","summaryclosed":"PO","summaryheader":"QO","summaryitems":"RO","summaryprice":"SO","buttonopen":"TO","buttondown":"UO","summaryfixed":"VO","usdnotification":"WO","renew":"XO","promowrapper":"YO","ordersummarywrap":"ZO","simplewrap":"aP"};
    if(module.hot) {
      // 1715091680513
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  